module.exports = __webpack_public_path__ + "20500503bdabc1c5b2628cbfd3e9ced5.pdf";